import React, {Component} from 'react';
import {Link} from "react-router-dom";

class List extends Component {

    constructor(props) {
        super(props)
        this.state = {
            users: [
                // {id:1,name:'jack'},
                // {id:2,name:'mary'},
            ],
        }
    }

    edit = (id) => {

        // this.props.history.push({pathname: this.props.match.path + "/edit", state: {id: id}})
        // 下个页面： console.log(this.props.location.state)
        // id不会显示在url中

        //this.props.history.push(this.props.match.path + "/edit/" + id)
    }

    componentDidMount() {
        //ajax
        this.setState({
            users: []
        })
    }

    render() {
        return (
            <div>

                <div>
                    <Link to="/user/create">新增</Link>
                </div>

                <table border="1">
                    <thead>
                    <tr>
                        <td>姓名</td>
                        <td>邮箱</td>
                        <td>操作</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>jack</td>
                        <td>jack@qq.com</td>
                        <td>
                            <Link to={this.props.match.path + "/edit/" + 1}>编辑</Link>
                        </td>
                    </tr>

                    <tr>
                        <td>jack</td>
                        <td>jack@qq.com</td>
                        <td>
                            <Link to={this.props.match.path + "/edit/" + 1}>编辑</Link>
                        </td>
                    </tr>

                    </tbody>
                </table>

            </div>
        );
    }
}

export default List;